import React from "react";

const toneClasses = {
    white: "text-white",
    softWhite: "text-white/80",
    gray: "text-gray-300",
    dark: "text-[#103a5d]",
    muted: "text-slate-500",
};

const sizeClasses = {
    sm: "text-sm",
    base: "text-[1.4rem] leading-[1.8rem]",
    md: "text-lg",
    lg: "text-xl",
    xl: "text-2xl",
};

const weightClasses = {
    normal: "font-normal",
    medium: "font-medium",
    semibold: "font-semibold",
    bold: "font-bold",
};

const variantClasses = {
    body: "",
    lead: "leading-relaxed",
    caption: "tracking-[0.01em]",
    heroSubtitle: "",
    button: "",
};

const variantSizeClasses = {
    body: "text-[1.4rem] leading-[1.8rem]",
    lead: "text-base lg:text-xl",
    caption: "text-sm",
    heroSubtitle: "text-[1.8rem] leading-[2.3rem] md:text-3xl xl:text-[38px] xl:leading-[40px]",
    button: "text-[1.35rem] leading-[1.7rem] md:text-lg xl:text-xl",
};

const UIText = ({
    as: Tag = "p",
    variant,
    tone = "gray",
    size = "base",
    weight = "normal",
    className = "",
    style,
    children,
}) => {
    const useVariantStyles = Boolean(variant);

    return (
        <Tag
            style={style}
            className={`${useVariantStyles ? variantClasses[variant] || "" : ""} ${useVariantStyles ? variantSizeClasses[variant] || "" : sizeClasses[size] || sizeClasses.base} ${toneClasses[tone] || toneClasses.gray} ${weightClasses[weight] || weightClasses.normal} ${className}`}
        >
            {children}
        </Tag>
    );
};

export default UIText;
